/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DashboardFilters,
  DashboardFilters$inboundSchema,
} from "./dashboardfilters.js";
import {
  DashboardPlacement,
  DashboardPlacement$inboundSchema,
} from "./dashboardplacement.js";

/**
 * A project's layout of saved widgets on a 12-column grid, under one date range and filter bar. Belongs to a project and is visible to everyone in it. Widgets are linked, not copied: editing one changes it on every dashboard it is on.
 */
export type Dashboard = {
  createdAt: Date;
  /**
   * Who made it, when known
   */
  createdByUserId?: string | undefined;
  /**
   * What the dashboard is for, when its creator said
   */
  description?: string | undefined;
  /**
   * What a dashboard opens on: its date range and the values picked for each catalog dimension its filter bar offers. Changes in the bar are a personal view until they are saved here.
   */
  filters: DashboardFilters;
  id: string;
  /**
   * Display name. Not unique.
   */
  name: string;
  organizationId: string;
  projectId: string;
  updatedAt: Date;
  /**
   * Its cards, in no particular order; the grid places them by position
   */
  widgets: Array<DashboardPlacement>;
};

/** @internal */
export const Dashboard$inboundSchema: z.ZodMiniType<Dashboard, unknown> = z
  .pipe(
    z.object({
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      created_by_user_id: z.optional(z.string()),
      description: z.optional(z.string()),
      filters: DashboardFilters$inboundSchema,
      id: z.string(),
      name: z.string(),
      organization_id: z.string(),
      project_id: z.string(),
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      widgets: z.array(DashboardPlacement$inboundSchema),
    }),
    z.transform((v) => {
      return remap$(v, {
        "created_at": "createdAt",
        "created_by_user_id": "createdByUserId",
        "organization_id": "organizationId",
        "project_id": "projectId",
        "updated_at": "updatedAt",
      });
    }),
  );

export function dashboardFromJSON(
  jsonString: string,
): SafeParseResult<Dashboard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Dashboard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Dashboard' from JSON`,
  );
}
